import { render } from "./TipDetail.vue?vue&type=template&id=835a79fe&scoped=true"
import script from "./TipDetail.vue?vue&type=script&lang=js"
export * from "./TipDetail.vue?vue&type=script&lang=js"

import "./TipDetail.vue?vue&type=style&index=0&id=835a79fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835a79fe"]])

export default __exports__